<template>
  <div id="resultModal" class="modal is-active">
    <div class="modal-background" @click.prevent="hideSettings" />
    <div class="modal-content">
      <div id="settings-box">
        <figure class="image is-4by3">
          <img src="/images/popup.png">
        </figure>
        <div class="content">
          <div id="title">
            <figure class="image">
              <img src="/images/settings.png">
            </figure>
          </div>
          <div class="setting">
            Music <a href="#" @click.prevent="toggleMusic"><figure class="image"><img :src="'/images/' + (musicOn ? 'soundOnIcon.png' : 'soundOffIcon.png')"></figure></a>
          </div>
          <div class="setting">
            Sound FX <a href="#" @click.prevent="toggleSoundFX"><figure class="image"><img :src="'/images/' + (soundFXOn ? 'soundOnIcon.png' : 'soundOffIcon.png')"></figure></a>
          </div>
          <div v-if="!number && location !== 'phonics'" class="setting">
            Letter Names <a href="#" @click.prevent="toggleLetterNames"><figure class="image"><img :src="'/images/' + (letterNamesOn ? 'soundOnIcon.png' : 'soundOffIcon.png')"></figure></a>
          </div>
          <div v-if="!pause" class="setting">
            Show Bonus Bar <a href="#" @click.prevent="toggleTimers"><figure class="image"><img :src="'/images/' + (disableTimer ? 'cross.png' : 'tick.png')"></figure></a>
          </div>
          <div v-if="(!pause || number) && allowInvertCalculator" class="setting">
            Invert Calculator <a href="#" class="has-text-dark" @click.prevent="toggleInvertCalc"><figure class="image"><i v-if="invertCalcOn" class="mdi mdi-check" /><i v-else class="mdi mdi-close" /></figure></a>
          </div>
          <div v-if="!pause && canChangeFont" class="setting">
            <label for="fontPreference">Game Font</label>

            <b-dropdown aria-role="list" position="is-top-left" class="settings_modal_font_select_dropdown" :value="fontPreference" @change="setFont($event)">
              <template #trigger="{ active }">
                <b-button
                  :style="{ 'font-family': getFontFamilyFromKey(fontPreference) }"
                  class="settings_modal_font_select_button"
                  :label="getFontNameFromKey(fontPreference)"
                  type="is-text"
                />
              </template>

              <b-dropdown-item v-for="(fontName, fontKey) in fontOptions" :key="fontKey" aria-role="listitem" :value="fontKey" :style="{ 'font-family': getFontFamilyFromKey(fontKey) }">
                {{ fontName }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div v-if="pause && lesson" id="quitButton">
            <a href="#" @click.prevent="quitLesson"><img src="/images/quitButton.png"></a>
          </div>
          <div v-if="pause && !lesson " id="quitButton">
            <a href="#" @click.prevent="quit"><img src="/images/quitButton.png"></a>
          </div>
        </div>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click.prevent="hideSettings" />
  </div>
</template>

<script>
import StylingMixin from '@/mixins/Helpers'
import config from '@/config'
import ModalMixin from '@/edshed-common/mixins/ModalMixin'
import { Api } from '@/edshed-common/api/methods'

export default {
  name: 'SettingsModal',
  mixins: [StylingMixin, ModalMixin],
  props: {
    pause: Boolean,
    number: Boolean,
    location: 'spelling' | 'number' | 'quiz' | 'phonics' | 'assignments' | 'quizshed' | null, // WTF?
    ident: String,
    allowInvertCalculator: Boolean,
    lesson: {
      type: Boolean,
      default: false
    },
    hasCustomQuitHandler: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      config
    }
  },
  computed: {
    musicOn () {
      return this.$store.state.musicOn
    },
    soundFXOn () {
      return this.$store.state.soundFXOn
    },
    letterNamesOn () {
      return this.$store.state.letterNamesOn
    },
    invertCalcOn () {
      return this.$store.state.invertCalcOn
    },
    disableTimer () {
      return this.$store.state.disableTimer
    },
    fontPreference () {
      return this.$store.state.fontPreference
    },
    canChangeFont () {
      return this.$store.state.canChangeFont
    },
    fontOptions () {
      const fonts = {
        dyslexic: 'Open Dyslexic',
        muli: 'Muli'
      }
      if (this.$i18n.locale === 'en-us') {
        fonts.sassoonUs = 'Sassoon'
      } else if (this.$i18n.locale === 'en-za') {
        fonts.sassoonZa = 'Sassoon'
      } else {
        fonts.sassoon = 'Sassoon'
        fonts.sassoonCurly = 'Sassoon Curly'
      }
      return fonts
    }
  },
  methods: {
    hideSettings () {
      this.$emit('hide')
    },
    getFontFamilyFromKey (fontKey) {
      switch (fontKey) {
        case 'dyslexic':
          return 'OpenDyslexicAltaRegular'
        case 'sassoon':
          return 'Sassoon'
        case 'sassoonCurly':
          return 'SassoonCurly'
        case 'sassoonUs':
          return 'SassoonUS'
        case 'sassoonZa':
          return 'SassoonZA'
        case 'muli':
          return 'Muli'
      }
    },
    getFontNameFromKey (fontKey) {
      return this.fontOptions[fontKey] || 'Default'
    },
    quitLesson () {
      if (this.$store.state.soundFXOn) {
        this.$sounds.clickSound.play()
      }

      this.$emit('quit-episode')
      this.$emit('hide')
    },
    async quit () {
      if (this.$store.state.soundFXOn) {
        this.$sounds.clickSound.play()
      }

      if (this.hasCustomQuitHandler) {
        this.$emit('quit-handler')
        return
      }

      const conf = await this.confirm({ title: 'Quit Game?', message: 'Are you sure you want to quit this game?' })
      if (conf) {
        if (this.location === 'quizshed') {
          const typeQL = this.ident.charAt(0) // identify if this.ident is a question or a lesson
          if (this.ident && typeQL === 'L') {
            window.location.href = this.config.serverInfo.quiz + this.$i18n.locale + '/lessons/' + this.ident
          } else if (this.ident && typeQL === 'Q') {
            window.location.href = this.config.serverInfo.quiz + this.$i18n.locale + '/browse/' + this.ident
          } else {
            window.location.href = this.config.serverInfo.quiz + this.$i18n.locale + '/browse/'
          }
        } else if (this.location === 'number' && this.$store.getters.hasNumber) {
          this.$router.push({ name: 'NumberMenu', params: { lang: this.$i18n.locale } })
        } else if (this.location === 'spelling' && this.$store.getters.hasSpelling) {
          this.$router.push({ name: 'SpellingMenu', params: { lang: this.$i18n.locale } })
        } else if (this.location === 'phonics' && this.$store.getters.hasSpelling) {
          this.$router.push({ name: 'Phonics Menu', params: { lang: this.$i18n.locale, map_tab: this.$route.params.map_tab || 'map', grapheme: this.$route.params.grapheme || '' } })
        } else if (this.location === 'assignments') {
          this.$router.push({ name: 'Assignments', params: { lang: this.$i18n.locale } })
        } else if (this.location === null) {
          this.$router.push({ name: 'MainMenu', params: { lang: this.$i18n.locale } })
        } else {
          this.$router.push({ name: 'QuizMenu', params: { lang: this.$i18n.locale } })
        }
      }
    },
    async updateUserSetting (setting, value) {
      await Api.setSettings({ [setting]: value })
    },
    toggleMusic () {
      const newValue = !this.musicOn
      this.$store.commit('SET_MUSIC', newValue)
      this.updateUserSetting('musicOn', newValue)
      if (newValue) {
        if (this.$sounds.backgroundMusic.state() === 'unloaded') {
          this.$sounds.backgroundMusic.load()
        }
        this.$sounds.backgroundMusic.play()
      } else {
        this.$sounds.backgroundMusic.stop()
      }
    },
    toggleSoundFX () {
      const newValue = !this.soundFXOn
      this.$store.commit('SET_SOUNDFX', newValue)
      this.updateUserSetting('soundFXOn', newValue)
      if (newValue && this.$sounds.clickSound.state() === 'unloaded') {
        this.$sounds.clickSound.load()
        this.$sounds.correctSound.load()
        this.$sounds.incorrectSound.load()
        this.$sounds.wellDoneSound.load()
      }
    },
    toggleLetterNames () {
      const newValue = !this.letterNamesOn
      this.$store.commit('SET_LETTERNAMES', newValue)
      this.updateUserSetting('letterNamesOn', newValue)
    },
    toggleInvertCalc () {
      const newValue = !this.invertCalcOn
      this.$store.commit('SET_INVERTCALC', newValue)
      this.updateUserSetting('invertCalcOn', newValue)
    },
    toggleTimers () {
      const newValue = !this.disableTimer
      this.$store.commit('SET_DISABLE_TIMERS', newValue)
      this.updateUserSetting('disableTimer', newValue)
    },
    setFont (fontPreference) {
      this.$store.commit('SET_FONT', fontPreference)
      this.updateUserSetting('fontPreference', fontPreference)
    }
  }
}
</script>

<style>
  .settings_modal_font_select_dropdown {
     float: right;
     clear: both;
  }
  .settings_modal_font_select_dropdown .dropdown-menu {
    background-color: #fff;
    border-radius: 6px;
  }
  .settings_modal_font_select_dropdown .dropdown-content {
    background: none;
  }
  .settings_modal_font_select_dropdown .dropdown-item {
    font-size: 0.65em;
  }
  .settings_modal_font_select_button {
    font-size: 0.65em;
    text-decoration: none !important;
  }
</style>

<style scoped>
  #fontPreference {
    margin-left: 0.5em;
    font-family: 'Cookies';
    font-size: 1em;
  }

  .modal-content {
    max-height:100vh;
    max-width: 530px;
  }

  #settings-box {
    position: relative;
  }

  .content {
    position: absolute;
    top: 0;
    padding:50px 50px 0;
    width:100%;
  }

  .content figure {
    margin: 0 2em;
  }

  #title img {
    width:350px;
    margin:0 auto;
  }

  .setting {
    font-family: 'Cookies';
    font-size:2em;
  }

  .setting a {
    float:right;
    clear:both;
  }

  .setting a figure {
    width:30px;
    margin: 0;
  }

  #quitButton {
    width: 160px;
    max-width:100%;
/*     margin-left: auto; */
  }

  @media all and (max-width: 639px) {
    .setting {
      font-size: 2em;
    }

    .setting a figure {
      width: 30px;
      margin: 0;
    }
  }

  @media all and (max-height: 360px) and (orientation: landscape) {

    .modal-content {
      max-width: 320px;
    }
    .content  {
      padding:20px 30px 0;
    }

    #title img {
      margin:0 auto;
      width: 200px;
    }

    .setting {
      font-size: 1.4em;
    }

    .setting a figure {
      width:25px;
      margin: 0;
    }

    #quitButton {
       width: 120px;
    }
  }

  @media all and (max-width: 479px)  {

    #title img {
      margin:0 auto;
      width: 150px;
    }

    .setting {
      font-size: 1.3em;
    }
    .content figure {
      margin:0;
    }

    .content  {
      padding:20px 30px 0;
    }

    .setting a figure {
      width:20px;
      margin: 0;
    }

    #quitButton {
       width: 120px;
    }

  }

</style>
